import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import './DateRange.css';

const today = moment();
const yesterday = moment().subtract(1, 'day');
const presets = [{
  text: 'Today',
  start: today,
  end: today,
},
{
  text: 'Yesterday',
  start: yesterday,
  end: yesterday,
},
{
  text: 'Last Week',
  start: moment().subtract(1, 'weeks').startOf('week'),
  end: moment().subtract(1, 'weeks').endOf('week'),
},
{
  text: 'Last 7 days',
  start: moment().subtract(7, 'day'),
  end: today,
},
{
  text: 'Last 30 days',
  start: moment().subtract(30, 'day'),
  end: today,
},
{
  text: 'Last Month',
  start: moment().subtract(1, 'months').startOf('month'),
  end: moment().subtract(1, 'months').endOf('month'),
},
{
  text: 'This week',
  start: moment().startOf('week'),
  end: today,
},
{
  text: 'This month',
  start: moment().startOf('month'),
  end: today,
},];

export default class DateRange extends Component {
  static propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      focusedInput: null
    }
    this.renderDatePresets = this.renderDatePresets.bind(this);
  }

  renderDatePresets() {
    return (
      <div className='preset'>
        {presets.map(({ text, start, end }) => {
          return (
            <button
              className = "btn"
              key={text}
              type="button"
              onClick={(e) => {
                this.props.onChange({startDate: start, endDate: end});
                this.setState({focusedInput : false});
              }}>
              {text}
            </button>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div className={`DateRange ${this.props.className ? this.props.className : ''}`}>
        <DateRangePicker
          startDate={this.props.startDate ? moment(this.props.startDate) : null}
          endDate={this.props.endDate ? moment(this.props.endDate) : null}
          onDatesChange={this.props.onChange}
          focusedInput={this.state.focusedInput}
          onFocusChange={focusedInput => this.setState({ focusedInput })}
          isOutsideRange={date => date > moment()}
          renderCalendarInfo={this.renderDatePresets}
          showClearDates
          enableOutsideDays
          anchorDirection={'right'}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DateRangeComponent/DateRange.js